/**
 * Build sport jersey avatar URL from blob storage.
 *
 * Contests can override the folder via `style_config.teamAssetFolder`. When the
 * folder is `teams` (logos), this still returns the sport's non-IP jersey path
 * so player art never swaps to licensed logos under League IP off.
 *
 * MLB has always used one file per team; NFL matches that (DKPLAT-604). NBA
 * non-IP team marks live under `team-jerseys`.
 */
import { resolveJerseyStyleTeamUrl } from '@/utils/teamAssetFolder';

/**
 * Returns the jersey avatar URL for a given sport and team code.
 * Falls back to empty string if the sport or team code is unavailable.
 *
 * @param sport - Sport code (e.g. 'MLB', 'NBA', 'NFL'). Defaults to 'MLB' for backward compatibility.
 * @param teamCode - 3-letter team abbreviation (e.g. BAL, NYY)
 */
export function getJerseyAvatarUrl(
  teamCode: string | null | undefined,
  sport: string | null | undefined = 'MLB',
  position?: string | null
): string {
  return resolveJerseyStyleTeamUrl(teamCode, sport, position);
}
